import React from 'react';
import QuestionCard from './QuestionCard';

export default function QuestionList({ filtered, API_HOST, token, setError, onEdit, onDelete, loading }) {
  if (loading) {
    // Skeleton loader for cards
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5" aria-busy="true">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="p-4 bg-gray-100 rounded-xl border border-gray-200 animate-pulse h-40" />
        ))}
      </div>
    );
  }
  if (!filtered || filtered.length === 0) {
    return (
      <div className="py-12 text-center border border-dashed border-gray-300 rounded-lg bg-gray-50 text-gray-500">
        <div className="flex flex-col items-center gap-2">
          <svg width="48" height="48" fill="none" viewBox="0 0 48 48"><circle cx="24" cy="24" r="22" stroke="#a5b4fc" strokeWidth="4" fill="#eef2ff" /><path d="M16 22h16M16 28h10" stroke="#6366f1" strokeWidth="2" strokeLinecap="round"/></svg>
          <div className="text-lg font-semibold">No questions found</div>
          <div className="text-sm">Try adjusting your filters or add a new question.</div>
        </div>
      </div>
    );
  }
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5" aria-label="Question list">
      {filtered.map(q => (
        <QuestionCard
          key={q.id}
          q={q}
          API_HOST={API_HOST}
          token={token}
          setError={setError}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
}
